<script setup lang="ts">
import { VIcons } from '@/shared/ui'

const model = defineModel<boolean | undefined>()

defineProps({
  icon: {
    type: String,
    required: true,
  },
  tooltip: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <VTooltip location="top" :text="tooltip">
    <template #activator="{ props: tipProps }">
      <VCheckbox
        class="pb-field-flag"
        v-bind="tipProps"
        v-model="model"
        :disabled="disabled"
        density="compact"
        hide-details
      >
        <template #label>
          <VIcons :type="icon" />
        </template>
      </VCheckbox>
    </template>
  </VTooltip>
</template>

<style scoped lang="scss">
.pb-field-flag {
  :deep(.v-selection-control) {
    min-height: 26px;
  }

  :deep(.v-selection-control__input) {
    width: 18px;
    height: 18px;
  }

  :deep(.v-selection-control__input > .v-icon) {
    font-size: 18px;
  }

  :deep(.v-label) {
    opacity: 1;

    .v-icon {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.54);
    }
  }
}
</style>
